import { render, staticRenderFns } from "./non-graphical-email-template-select-widget.vue?vue&type=template&id=a888954e&"
import script from "./non-graphical-email-template-select-widget.vue?vue&type=script&lang=js&"
export * from "./non-graphical-email-template-select-widget.vue?vue&type=script&lang=js&"
import style0 from "./non-graphical-email-template-select-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports